import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireDayjs_min } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js";
var dayjs_minExports = requireDayjs_min();
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
export {
  dayjs as default
};
//# sourceMappingURL=dayjs.min.js.map
